import { IgTypography } from "@intelligems/ig-theme";
import Grid from "@mui/material/Grid";
import { useExecutionPanelContext } from "@src/features/ai/components/WorkflowEditor/execution/panel/ExecutionPanelContext";

/** "AI may make mistakes" notice shown beneath the composer. */
export const AiDisclaimer = () => {
  const { aiChat, compact } = useExecutionPanelContext();

  return (
    <Grid textAlign={"center"} sx={{ pt: 3, lineHeight: "14px" }}>
      <IgTypography variant="body3" sx={{ color: "text.secondary" }}>
        Intelligems AI may make mistakes. We recommend verifying information
        shared through this chat.{" "}
      </IgTypography>
    </Grid>
  );
};
